module.exports = __webpack_public_path__ + "img/other_meizu1.54562df1.jpg";